var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-subheader',[_vm._v("Ajout d'un numéro de téléphone")]),_c('v-row',[_vm._t("add")],2),_c('v-subheader',[_vm._v("Liste des associations")]),_vm._t("list")],2)}
var staticRenderFns = []

export { render, staticRenderFns }